/**
 * User Data Model
 *
 * This defines the structure of user data stored in DynamoDB
 * and synchronized with Cognito custom attributes.
 */
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "admin";
    UserRole["EMPLOYEE"] = "employee";
    UserRole["SUPERADMIN"] = "superadmin";
})(UserRole || (UserRole = {}));
/**
 * Data access patterns:
 *
 * 1. Get user by ID (Cognito sub)
 *    - Primary key query: userId
 *
 * 2. Get user by email
 *    - GSI query: EmailIndex
 *
 * 3. List all users in a company
 *    - GSI query: CompanyIndex (partitionKey: companyId)
 *
 * 4. List all admins/employees in a company
 *    - GSI query: CompanyIndex (partitionKey: companyId, sortKey: role)
 */
